export const SEARCH_TRACKING_EVENT_TYPE = {
  FM_GLOBAL_SEARCH: 'fmGlobalSearch',
  FMDIR_GLOBAL_SEARCH: 'fmdirGlobalSearch',
  FM_TERMS_QUICK_SEARCH: 'fmTermsQuickSearch',
  FM_TAGS_QUICK_SEARCH: 'fmTagsQuickSearch',
  FMDIR_SEARCH_HISTORY_QUICK_SEARCH: 'fmdirSearchHistoryQuickSearch'
}
